var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.dataForm.id ? 'Edit Exchange Rate' : 'Add Exchange Rate',
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "width": "600px",
      "top": "2vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "autocomplete": "off",
      "label-width": "130px",
      "label-position": "left"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 60
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "End of Period",
      "prop": "month"
    }
  }, [_c('el-date-picker', {
    staticClass: "wdb100",
    attrs: {
      "type": "month",
      "value-format": "yyyyMM",
      "clearable": "",
      "placeholder": "Select Month"
    },
    model: {
      value: _vm.dataForm.month,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "month", $$v);
      },
      expression: "dataForm.month"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticClass: "wdb100",
    attrs: {
      "data": _vm.dataForm.tableDataList,
      "height": "63vh"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Exchange Rates",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('span', [_vm._v("S$ Per " + _vm._s(scope.row.exchangeRateBasis) + " Units of " + _vm._s(scope.row.currency))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('el-input-number', {
          staticClass: "tal wdb100",
          attrs: {
            "precision": 6,
            "min": 0,
            "step": 0.000001,
            "controls-position": "right"
          },
          model: {
            value: scope.row.exchangeRateValue,
            callback: function callback($$v) {
              _vm.$set(scope.row, "exchangeRateValue", $$v);
            },
            expression: "scope.row.exchangeRateValue"
          }
        })];
      }
    }])
  })], 1)], 1), _c('el-col', {
    staticClass: "pt16",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Attachments",
      "prop": "attachmentUrls"
    }
  }, [_c('el-multiple-file-uploader', {
    model: {
      value: _vm.dataForm.attachmentUrls,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "attachmentUrls", $$v);
      },
      expression: "dataForm.attachmentUrls"
    }
  })], 1)], 1)], 1)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }